'use client';

export { default } from '../HomeClient';
